import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConstantsService } from './api-constants.service';
import { Observable } from 'rxjs';
import {
  CreateCurrencyParams,
  Currency,
  CurrencyListParams
} from '~core/models/currency.models';
import { Pagination } from '~core/models/core.models';

@Injectable()
export class CurrenciesService {
  private _httpClient = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  readonly apiUrl = this._apiConstantsService.currenciesUrl;

  list(params?: CurrencyListParams): Observable<Pagination<Currency>> {
    return this._httpClient.get<Pagination<Currency>>(this.apiUrl, { params });
  }

  read(currencyId: string): Observable<Currency> {
    return this._httpClient.get<Currency>(`${this.apiUrl}/${currencyId}`);
  }

  create(params: CreateCurrencyParams): Observable<Currency> {
    return this._httpClient.post<Currency>(this.apiUrl, params);
  }

  update(
    currencyId: string,
    params: Partial<CreateCurrencyParams>
  ): Observable<Currency> {
    return this._httpClient.patch<Currency>(
      `${this.apiUrl}/${currencyId}`,
      params
    );
  }

  delete(currencyId: string): Observable<void> {
    return this._httpClient.delete<void>(`${this.apiUrl}/${currencyId}`);
  }
}
